module.exports = "//static.hsappstatic.net/WebsiteGraderUI/static-1.1473/img/iphone-frame.png"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./img/iphone-frame.png
// module id = 302
// module chunks = 0